module.exports = __webpack_public_path__ + "static/media/tcs1.3dd5c0b5.png";